module.exports = __webpack_public_path__ + "img/bedroom.7a313467.svg";